import ChatState from '../store/schema/ChatState';
import { mutator } from 'satcheljs';
import { addChat, setChatState } from '../actions/ucmaActions';
import { getStore } from '../store/chatStore';

mutator(addChat, actionMessage => {
    const store = getStore();
    store.chats.push(actionMessage.chat);
});

mutator(setChatState, actionMessage => {
    const { chat, state } = actionMessage;
    chat.state = state;
    if (chat.state == ChatState.Normal) {
        chat.lastReadMessageSequence = chat.lastMessageSequence;
    }
});
